import { Box, Image, Text } from '@wix/design-system'
import React, { FC } from 'react'

import s from './Option.scss'

type Props = {
  title: string
  description: string
  imgSrc: string
  alt?: string
  onClick: () => void
  dataHook?: string
}

export const Option: FC<Props> = ({ title, description, imgSrc, alt, onClick, dataHook }) => {
  return (
    <div onClick={onClick}>
      <Box
        gap="24px"
        minWidth="640px"
        maxWidth="660px"
        textAlign="center"
        margin="0 auto"
        padding="18px"
        className={s.container}
        dataHook={dataHook}
      >
        <Box minWidth="90px">
          <Image src={imgSrc} alt={alt} className={s.img} />
        </Box>

        <Box className={s.content} verticalAlign="middle">
          <Box direction="vertical" textAlign="left" verticalAlign="middle">
            <Text weight="bold" className={s.textCenter}>
              {title}
            </Text>
            <Text className={s.textCenter}>{description}</Text>
          </Box>

          <ArrowIcon />
        </Box>
      </Box>
    </div>
  )
}

const ArrowIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2929 13H5V12H17.2929L13.1452 7.86039C12.95 7.66513 12.95 7.34854 13.1452 7.15328C13.3405 6.95802 13.6571 6.95802 13.8523 7.15328L19.2071 12.5L13.8523 17.8553C13.6571 18.0506 13.3405 18.0506 13.1452 17.8553C12.95 17.6601 12.95 17.3435 13.1452 17.1482L17.2929 13Z"
        fill="#000624"
      />
    </svg>
  )
}
